import React from "react";
import "./RollResultRow.scss";
import UserAvatar from "./UserAvatar";
import ReactTooltip from "react-tooltip";
import { RollResult, Die } from "../models/messages";
import DieIcon from "./DieIcon";
import Moment from "react-moment";
import { AvatarDef } from "../models/messages";
import { DICE } from "../constants/general";

interface Props {
  rollResult: RollResult;
  rollerAvatar: AvatarDef;
}

export default function RollResultRow(props: Props) {
  const { rollResult, rollerAvatar } = props;

  return (
    <div className="c-roll-result container py-3 mx-2 border-bottom">
      <div className="row">
        <div className="col-7 col-md-2 order-1 order-md-1 d-flex flex-row justify-content-start align-items-center text-light">
          <div className="small text-muted text-center mr-2">
            <Moment format="hh:mm" parse="X">
              {rollResult.utc_timestamp}
            </Moment>
          </div>
          <div className="ml-1 d-flex flex-column" data-tip={"You"} data-place="bottom">
            <UserAvatar avatarDef={rollerAvatar} />
          </div>
        </div>
        <div className="col-12 col-md-8 order-3 order-md-2 d-flex flex-row justify-content-start align-items-center text-light">
          <div className="d-flex flex-grow-1 flex-row flex-wrap justify-content-center align-items-center mr-3">
            {DICE.map(
              (die) =>
                rollResult.rolled_dice.rolled_dice[die as Die]?.length > 0 && (
                  <div className="d-flex flex-row align-items-center justify-items-center m-3" key={die}>
                    <h4 className="d-inline text-light mx-3">
                      <DieIcon die={die as Die} />
                    </h4>
                    <h4 className="d-inline text-center">{rollResult.rolled_dice.rolled_dice[die as Die].join(" ")}</h4>
                  </div>
                )
            )}
          </div>
        </div>
        <div className="col-5 col-md-2 order-2 order-md-3 d-flex flex-row justify-content-start align-items-center text-light">
          <div className=" text-right ml-auto mr font-weight-bold">
            <h2>{rollResult.rolled_dice.total_value}</h2>
          </div>
        </div>
      </div>
      <ReactTooltip effect="solid" type="dark" />
    </div>
  );
}
